import { OaiboxType, RanMode } from "@allbesmart/web-app-common";

export function isAiRanType(
  oaiboxType: OaiboxType | null | undefined
): boolean {
  return (
    oaiboxType === OaiboxType.OAIBOX_AI_RAN ||
    oaiboxType === OaiboxType.OCUDU_KIT
  );
}

export function defaultRanMode(
  oaiboxType: OaiboxType | null | undefined
): RanMode {
  return oaiboxType === OaiboxType.OCUDU_KIT ? RanMode.OCUDU : RanMode.DURANTA;
}
